export enum GLDashboardWidget {
  topRowWidget = 'topRowWidget',
  optimization = 'optimization',
  pareto = 'pareto',
  opportunities = 'opportunities',
}
export enum TopWidgetKey {
  WellsEnabled = 'WellsEnabled',
  WellsRunning = 'WellsRunning',
  WellsNoTests = 'WellsNoTests',
  CountHighDaysSinceTested = 'CountHighDaysSinceTested',
  WellsOutOfService = 'WellsOutOfService',
}
export type WellSummaryKey = keyof typeof TopWidgetKey;
export interface OptimizationSummaryItem {
  text: string;
  value: number;
  wellcount: number;
  navigateState: Record<string, string>;
}
